export class SimpleInstance
{
    id: string;
    name: string;
}